import axios from "axios";
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Collapse,
  CardBody,
  Card,
  CardHeader,
  Row,
  Col,
  Badge,
} from "reactstrap";
import Paper from "@material-ui/core/Paper";
import { forEach } from "lodash";
import { Anchor } from "grommet";
import McqAssesment from "./LearnerAssesment/McqAssesment";
import ProjectAssesment from "./LearnerAssesment/ProjectAssesment";
import MtfAssesment from "./LearnerAssesment/MtfAssesment";
import HandsonAssesment from "./LearnerAssesment/HandsonAssesment";
import MwaAssesment from "./LearnerAssesment/MwaAssesment";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Spinner from "../sample/spinner";
import Chip from "@material-ui/core/Chip";
import LearnerAssesment from "./LearnerAssesment/LearnerAssesment";
import { toast } from "react-toastify";
class Assesment extends Component {
  constructor(props) {
    super(props);
    const courseout = [];
    this.toggle = this.toggle.bind(this);
    this.state = {
      coursesmenu: true,
      isLoading: false,
      isVisible: false,
      courseout,
      collapseBanner: "",
      collapseCycle: "",
      collapseReleaseDate: "",
      collapseLayout: "",
      setmyview: "",
      contentid: "",
      contenttype: "",
      videoid: "",
      materialid: "",
      materiapath: "",
      materialtype: "",
      showComponent: false,
    };
  }
  componentDidMount() {
    this.getcourseAssesment();
  }
   scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };
  toggle(e) {
    let event = e.target.dataset.event;
    let key = e.target.dataset.type;
    switch (key) {
      case "collapseBanner": {
        this.setState({
          collapseBanner: event,
          collapseCycle: "",
          collapseReleaseDate: "",
          collapseLayout: "",
        });
        break;
      }
      case "collapseCycle": {
        this.setState({
          collapseCycle: event,
          collapseReleaseDate: "",
          collapseLayout: "",
        });
        break;
      }
      case "collapseReleaseDate": {
        this.setState({
          collapseReleaseDate: event,
          collapseLayout: "",
          collapseCycle: "",
        });
        break;
      }
      case "collapseLayout": {
        this.setState({ collapseLayout: event });
        break;
      }
      default:
        break;
    }
  }
  async getcourseAssesment() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    axios
      .post("LearnerCourse/courseAssesment", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            showComponent: false,
            courseout: res.data.courseout,
          });
          // console.log(this.state.courseout);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  renderTopic(Topic) {
    let result = [];
    forEach(Topic, (topic, bannerId) => {
      result.push(
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="typography-topic"
          >
            <Typography>{topic.topic}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{this.renderTopicContent(topic)}</Typography>
          </AccordionDetails>
        </Accordion>
        // <Card style={{ marginBottom: "1rem" }} key={topic.topic}>
        //   <CardHeader
        //     onClick={this.toggle}
        //     data-event={topic.topic}
        //     data-type="collapseCycle"
        //   >
        //     {" "}
        //     {topic.topic}
        //   </CardHeader>
        //   <Collapse isOpen={this.state.collapseCycle === topic.topic}>
        //     <CardBody>{this.renderTopicContent(topic)}</CardBody>
        //   </Collapse>
        // </Card>
      );
    });
    return result;
  }

  renderTopicContent(topicContent) {
    let result = [];
    result.push(
      <>
        <Card
          style={{ marginBottom: "1rem" }}
          key={topicContent.topicid}
          className="name-card"
        >
          <div className="row">
            {topicContent.mcqTopic &&
            topicContent.mcqTopic[0].mcqtopicsize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
                <Anchor
                  onClick={(e) =>
                    {this.setState({
                      setmyview: "Mcq",
                      contentid: topicContent.topicid,
                      contenttype: "Topiclevel",
                    });
                     window.scrollTo(0, 0);
                  }
                  }
                >
                  <img
                    src="/assets/images/icons/mcq.svg"
                    height="20"
                    width="20"
                    alt="mcq"
                  />{" "}
                  &nbsp;MCQ ({topicContent.mcqTopic[0].mcqtopicsize})
                </Anchor>
              </div>
            ) : (
              ""
            )}

            {topicContent.projectTopic[0] &&
            topicContent.projectTopic[0].projectTopicsize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
                <Anchor
                  onClick={(e) =>
                    { this.setState({
                      setmyview: "Project",
                      contentid: topicContent.topicid,
                      contenttype: "Topiclevel",
                    });
                    window.scrollTo(0, 0);}
                  }
                >
                  <img
                    src="/assets/images/icons/subjective.svg"
                    height="20"
                    width="20"
                    alt="Project"
                  />{" "}
                  Project ({topicContent.projectTopic[0].projectTopicsize})
                </Anchor>
              </div>
            ) : (
              ""
            )}

            {topicContent.mtfTopic[0].mtfTopicsize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
                <Anchor
                  onClick={(e) =>{
                    this.setState({
                      setmyview: "Mtf",
                      contentid: topicContent.topicid,
                      contenttype: "Topiclevel",
                    });window.scrollTo(0, 0);}
                  }
                >
                  <img
                    src="/assets/images/icons/vmms_match.svg"
                    height="20"
                    width="20"
                    alt="Match the following"
                  />{" "}
                  Match The Following ({topicContent.mtfTopic[0].mtfTopicsize})
                </Anchor>
              </div>
            ) : (
              ""
            )}

            {topicContent.handsonTopic[0].handsonTopicsize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
                <Anchor
                  onClick={(e) =>{
                    this.setState({
                      setmyview: "Handson",
                      contentid: topicContent.topicid,
                      contenttype: "Topiclevel",
                    });window.scrollTo(0, 0);}
                  }
                >
                  <img
                    src="/assets/images/icons/handson.svg"
                    height="20"
                    width="20"
                    alt="HandsOn"
                  />{" "}
                  HandsOn ({topicContent.handsonTopic[0].handsonTopicsize})
                </Anchor>
              </div>
            ) : (
              ""
            )}

            {topicContent.multiwordanswerTopic[0].multiwordanswerTopicsize >
            0 ? (
              <div className="col-lg-6 cl-b pb-2">
                <Anchor
                  onClick={(e) =>{
                    this.setState({
                      setmyview: "Mwa",
                      contentid: topicContent.topicid,
                      contenttype: "Topiclevel",
                    });window.scrollTo(0, 0);}
                  }
                >
                  <img
                    src="/assets/images/icons/vmms_fill-blanks.svg"
                    height="20"
                    width="20"
                    alt="Fill The Gap"
                  />{" "}
                  Fill The Gap (
                  {
                    topicContent.multiwordanswerTopic[0]
                      .multiwordanswerTopicsize
                  }
                  )
                </Anchor>
              </div>
            ) : (
              ""
            )}
          </div>
        </Card>
      </>
    );

    return result;
  }
  renderCourse(course) {
    let result = [];
    result.push(
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{"Unit Level Content"}</Typography>
        </AccordionSummary>
        {/* <Card
        style={{ marginBottom: "1rem" }}
        key={course.courseoutline_courselevel}
      >
        <CardHeader
          onClick={this.toggle}
          data-event={course.courseoutline_courselevel}
          data-type="collapseReleaseDate"
        >
          {"Unit Level Content"}
        </CardHeader>
        <Collapse
          isOpen={
            this.state.collapseReleaseDate === course.courseoutline_courselevel
          }
        >
          <CardBody>
            <Card style={{ marginBottom: "1rem" }} key={course.courseid}> */}
        <AccordionDetails>
          <Typography>

          <Card
          style={{ marginBottom: "1rem" }}
           key={course.courseid}
          className="name-card"
        >

<div className="row">
            {course?.mcqcourse && course.mcqcourse[0].mcqCoursesize > 0 ? (
               <div className="col-lg-6 cl-b pb-2">
              <Anchor
                onClick={(e) =>
                  this.setState({
                    setmyview: "Mcq",
                    contentid: course.courseid,
                    contenttype: "Unitlevel",
                  })
                }
              >
                <img
                    src="/assets/images/icons/mcq.svg"
                    height="20"
                    width="20"
                    alt="mcq"
                  />{" "}
                  &nbsp;MCQ ({course.mcqcourse[0].mcqCoursesize})
              </Anchor>

              </div>
            ) : (
              ""
            )}
            {course.projectcourse &&
            course.projectcourse[0].projectCoursesize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
              <Anchor
                onClick={(e) =>
                  this.setState({
                    setmyview: "Project",
                    contentid: course.courseid,
                    contenttype: "Unitlevel",
                  })
                }
              >
                <img
                    src="/assets/images/icons/subjective.svg"
                    height="20"
                    width="20"
                    alt="Project"
                  /> &nbsp; {" "} Project ({course.projectcourse[0].projectCoursesize})
              </Anchor>
              </div>
            ) : (
              ""
            )}
            {course.mtfCourse && course.mtfCourse[0].mtfCoursesize > 0 ? (
               <div className="col-lg-6 cl-b pb-2">
              <Anchor
                onClick={(e) =>
                  this.setState({
                    setmyview: "Mtf",
                    contentid: course.courseid,
                    contenttype: "Unitlevel",
                  })
                }
              > <img
              src="/assets/images/icons/vmms_match.svg"
              height="20"
              width="20"
              alt="Match the following"
            /> &nbsp;
                Match The Following ({course.mtfCourse[0].mtfCoursesize})
              </Anchor>
              </div>
            ) : (
              ""
            )}
            {course.handsonCourse &&
            course.handsonCourse[0].handsonCoursesize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
              <Anchor
                onClick={(e) =>
                  this.setState({
                    setmyview: "Handson",
                    contentid: course.courseid,
                    contenttype: "Unitlevel",
                  })
                }
              ><img
              src="/assets/images/icons/handson.svg"
              height="20"
              width="20"
              alt="HandsOn"
            />&nbsp;
                HandsOn ({course.handsonCourse[0].handsonCoursesize})
              </Anchor>
              </div>
            ) : (
              ""
            )}
            {course.multiwordanswerCourse &&
            course.multiwordanswerCourse[0].multiwordanswerCoursesize > 0 ? (
              <div className="col-lg-6 cl-b pb-2">
              <Anchor
                onClick={(e) =>
                  this.setState({
                    setmyview: "Mwa",
                    contentid: course.courseid,
                    contenttype: "Unitlevel",
                  })
                }
              ><img
              src="/assets/images/icons/vmms_fill-blanks.svg"
              height="20"
              width="20"
              alt="Fill The Gap"
            />{" "}
            Fill The Gap (
                {course.multiwordanswerCourse[0].multiwordanswerCoursesize})
              </Anchor>
              </div>
            ) : (
              ""
            )}
 </div>
</Card>
          </Typography>
        </AccordionDetails>
        {/* </Card>
          </CardBody>
        </Collapse>
      </Card> */}
      </Accordion>
    );
    return result;
  }

  renderOutline() {
    let result = [];
    forEach(this.state.courseout, (courseout, bannerId) => {
      result.push(
        <>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>{courseout.course.courseoutline}</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography>
                {courseout.course.marksoutof > 0 ? (
                  <>
                    <Anchor
                      onClick={(e) =>
                        this.setState({
                          setmyview: "myassesment",
                          contentid: courseout.course.courseid,
                          contenttype: "Unitlevel",
                        })
                      }
                    >
                      <Chip
                        label={
                          <>
                            <b>
                              Marks Obtain : {courseout.course.marksobtained}
                            </b>
                          </>
                        }
                        color="primary"
                        variant="outlined"
                      />
                      &nbsp;
                      <Chip
                        label={
                          <>
                            <b> Out off : {courseout.course.marksoutof}</b>
                          </>
                        }
                        color="primary"
                        variant="outlined"
                      />
                    </Anchor>
                    <br /> <br />
                  </>
                ) : (
                  ""
                )}
                {(courseout.course.mcqcourse &&
                  courseout.course.mcqcourse[0].mcqCoursesize > 0) ||
                (courseout.course.projectcourse &&
                  courseout.course.projectcourse[0].projectCoursesize) > 0 ||
                (courseout.course.mtfCourse &&
                  courseout.course.mtfCourse[0].mtfCoursesize) > 0 ||
                (courseout.course.handsonCourse &&
                  courseout.course.handsonCourse[0].handsonCoursesize) ||
                (courseout.course.multiwordanswerCourse &&
                  courseout.course.multiwordanswerCourse[0]
                    .multiwordanswerTopicsize) > 0 ||
                courseout.Topic.length > 0 ? (
                  <>
                    {courseout.Topic.length > 0 ? (
                      <>{this.renderTopic(courseout.Topic)}</>
                    ) : (
                      ""
                    )}
                    {(courseout.course.mcqcourse &&
                      courseout.course.mcqcourse[0].mcqCoursesize > 0) ||
                    (courseout.course.projectcourse &&
                      courseout.course.projectcourse[0].projectCoursesize) >
                      0 ||
                    (courseout.course.mtfCourse &&
                      courseout.course.mtfCourse[0].mtfCoursesize) > 0 ||
                    (courseout.course.handsonCourse &&
                      courseout.course.handsonCourse[0].handsonCoursesize) ||
                    (courseout.course.multiwordanswerCourse &&
                      courseout.course.multiwordanswerCourse[0]
                        .multiwordanswerTopicsize) > 0 ? (
                      <> {this.renderCourse(courseout.course)}</>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <p class="notopic">No Contents Available For This Unit</p>
                )}
                {/* <> {this.renderCourse(courseout.course)}</> */}
                {/* {courseout.Topic.length > 0 ? (
                  <>
                    {this.renderTopic(courseout.Topic)}
                  </>
                ) : (courseout.course.mcqcourse &&
                    courseout.course.mcqcourse[0].mcqCoursesize > 0) ||
                  (courseout.course.projectcourse &&
                    courseout.course.projectcourse[0].projectCoursesize) > 0 ||
                  (courseout.course.mtfCourse &&
                    courseout.course.mtfCourse[0].mtfCoursesize) > 0 ||
                  (courseout.course.handsonCourse &&
                    courseout.course.handsonCourse[0].handsonCoursesize) ||
                  (courseout.course.multiwordanswerCourse &&
                    courseout.course.multiwordanswerCourse[0]
                      .multiwordanswerTopicsize) > 0 ? (
                  <> {this.renderCourse(courseout.course)}</>
                ) : (
                  <>
                    <p class="notopic">No Contents Available For This Unit</p>
                  </>
                )}  */}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </>
        // <Card
        //   style={{ marginBottom: "1 rem", background: " rgba(29,124,248,.05)" }}
        //   key={courseout.course.courseoutline}
        // >
        //   <CardHeader
        //     onClick={this.toggle}
        //     data-event={courseout.course.courseoutline}
        //     data-type="collapseBanner"
        //   >
        //     <p className="card-header-sub">
        //       {courseout.course.courseoutline}
        //       <Anchor
        //         class="click-layer"
        //         onClick={this.toggle}
        //         data-event={courseout.course.courseoutline}
        //       ></Anchor>
        //     </p>
        //   </CardHeader>
        //   <Collapse
        //     isOpen={
        //       this.state.collapseBanner === courseout.course.courseoutline
        //     }
        //   >
        //     <CardBody>
        //       {this.renderTopic(courseout.Topic)}
        //       {this.renderCourse(courseout.course)}
        //     </CardBody>
        //   </Collapse>
        // </Card>
      );
    });
    return result;
  }
  render() {
    return (
      <div>
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          <>
            <Card className="bg-color-tab">
              {this.state.courseout.length === 0 ? (
                <>
                  <center>
                    <br /> <br />
                    <img
                      dir="images"
                      src="/assets/images/icons/no-announcement.svg"
                      alt=""
                      width="300"
                      height="150"
                      className="img-thumbnail"
                    />
                    <br /> <br />
                    <h6>" No webinars!"</h6>
                  </center>
                </>
              ) : (
                <>
                  {this.state.coursesmenu ? (
                    <Row>
                      <Col lg={8} className="container pt-2 pl-lg-4">
                        {(() => {
                          switch (this.state.setmyview) {
                            case "Mcq":
                              //  return <Route  render={(props) => <McqAssesment contentType={this.state.contenttype} contentId={this.state.contentid} />} />
                              return (
                                <McqAssesment
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                />
                              );
                            case "Project":
                              return (
                                <ProjectAssesment
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                />
                              );
                            case "Mtf":
                              return (
                                <MtfAssesment
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                />
                              );
                            case "Handson":
                              return (
                                <HandsonAssesment
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                />
                              );
                            case "Mwa":
                              return (
                                <MwaAssesment
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                />
                              );
                            case "myassesment":
                              return (
                                <LearnerAssesment
                                  contentType={this.state.contenttype}
                                  contentId={this.state.contentid}
                                />
                              );
                            default:
                              return "";
                          }
                        })()}
                        {}
                      </Col>
                      <Col lg={4} className="bg-acc-white accordian">
                        <Paper className="p132-2">
                          Assesment
                          <FontAwesomeIcon
                            className="cross-icon"
                            icon={faTimesCircle}
                            onClick={() =>
                              this.setState({
                                coursesmenu: !this.state.coursesmenu,
                              })
                            }
                          />
                        </Paper>
                        <br />
                        {/* <Badge
                          className="button-course-content"
                          color="light"
                          onClick={() =>
                            this.setState({
                              coursesmenu: !this.state.coursesmenu,
                            })
                          }
                        >
                          <FontAwesomeIcon
                            className="cross-icon"
                            icon={faTimesCircle}
                          />
                        </Badge> */}
                        <div id="style-6" class=" mr-te  desc scrollbarcontent">
                          <span class="force-overflowcontent ">
                            {this.renderOutline()}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col lg={12}>
                        <Badge
                          className="button-course-content-right"
                          color="light"
                          onClick={() =>
                            this.setState({
                              coursesmenu: !this.state.coursesmenu,
                            })
                          }
                        >
                          <FontAwesomeIcon
                            className="course-content-icon"
                            icon={faArrowAltCircleLeft}
                          />
                          <span className="course-content"> Assesment</span>
                        </Badge>{" "}
                        &nbsp; &nbsp; &nbsp; &nbsp;
                      </Col>
                      <Col lg={12}>
                        <div className="container">
                          <br />
                          {(() => {
                            switch (this.state.setmyview) {
                              case "Mcq":
                                //  return <Route  render={(props) => <McqAssesment contentType={this.state.contenttype} contentId={this.state.contentid} />} />
                                return (
                                  <McqAssesment
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                  />
                                );
                              case "Project":
                                return (
                                  <ProjectAssesment
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                  />
                                );
                              case "Mtf":
                                return (
                                  <MtfAssesment
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                  />
                                );
                              case "Handson":
                                return (
                                  <HandsonAssesment
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                  />
                                );
                              case "Mwa":
                                return (
                                  <MwaAssesment
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                  />
                                );
                              case "myassesment":
                                return (
                                  <LearnerAssesment
                                    contentType={this.state.contenttype}
                                    contentId={this.state.contentid}
                                  />
                                );
                              default:
                                return "";
                            }
                          })()}
                        </div>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </Card>
          </>
        )}
      </div>
    );
  }
}

export default Assesment;
